import React from "react";
import { StyledButton, StyledHCard, StyledService } from "../components/Styles";

import img11 from "../components/Styles/assets/img11.webp";
import Accessibility from "../components/Styles/assets/Graphics/Accessibility.webp";
import Engagement from "../components/Styles/assets/Graphics/Engagement.webp";
import Experience from "../components/Styles/assets/Graphics/Experience.webp";
import Growth from "../components/Styles/assets/Graphics/Growth.webp";
import Visibility from "../components/Styles/assets/Graphics/Visibility.webp";
import Operations from "../components/Styles/assets/Graphics/Operations.webp";

import { Link } from "react-router-dom";
import Consultation from "../components/Consultation";

import { useTranslation } from "react-i18next";
import { slugs } from "../config/slugs";

function MobileApplication() {
  const { i18n, t } = useTranslation();

  const advantages = [
    "accessibility",
    "engagement",
    "operations",
    "visibility",
    "experience",
    "growth"
  ];

  const icons = {
    accessibility: Accessibility,
    engagement: Engagement,
    operations: Operations,
    visibility: Visibility,
    experience: Experience,
    growth: Growth
  };

  return (
    <StyledService.Container>
      <StyledService.Hero>
        <StyledService.Content>
          <StyledService.Title lang={i18n.language}>{t("mobileApplication.title")}</StyledService.Title>
          <StyledService.Description>
            {t("mobileApplication.description")}
          </StyledService.Description>
          <Link to={`/${i18n.language}/${slugs.contact[i18n.language]}`}>
            <StyledButton.Main>{t("mobileApplication.cta")}</StyledButton.Main>
          </Link>
        </StyledService.Content>
        <StyledService.ImageContainer>
          <img
            src={img11}
            alt={t("mobileApplication.title")}
            style={{ width: "100%", height: "auto", borderRadius: "10px" }}
          />
        </StyledService.ImageContainer>
      </StyledService.Hero>

      <Consultation />

      <StyledService.H3 lang={i18n.language}>{t("mobileApplication.advantagesTitle")}</StyledService.H3>

      <StyledHCard.Container>
        {advantages.map((key) => (
          <StyledHCard.SingleCard key={key}>
            <StyledHCard.IconContainer>
              <img src={icons[key]} alt={key} />
            </StyledHCard.IconContainer>
            <StyledHCard.Content>
              <StyledHCard.Title>
                {t(`mobileApplication.advantages.${key}.title`)}
              </StyledHCard.Title>
              <StyledHCard.Description>
                {t(`mobileApplication.advantages.${key}.desc`)}
              </StyledHCard.Description>
            </StyledHCard.Content>
          </StyledHCard.SingleCard>
        ))}
      </StyledHCard.Container>

      <Consultation />
    </StyledService.Container>
  );
}

export default MobileApplication;